import {copilot} from '@cl/shared';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import {Event, EventLogger} from '../../copilot.types';

export default function defaultEventLogger(): EventLogger {
  return {
    log(event: Event) {
      if (isFlagEnabled(FeatureFlagKey.EnableCopilotDebugMode)) {
        console.log(`[copilot] ${event.type}:`, event);
      }

      copilot.addToEventsLog(event);
    },
  };
}
